import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/primary/landing-content-popup-3.png")